import { getVoiceProfile, isVoiceProfileFailed, } from "@/shared/api/voice";
export class PollCancelledError extends Error {
    constructor() {
        super("poll cancelled");
        this.name = "PollCancelledError";
    }
}
export class PollTimeoutError extends Error {
    constructor() {
        super("poll timeout");
        this.name = "PollTimeoutError";
    }
}
/**
 * Поллинг профиля голоса до выполнения `until` (или до status=failed → reject).
 * Отмена через `isCancelled` (например, флаг размонтирования) — тогда reject
 * `PollCancelledError`, который вызывающий тихо игнорирует. Таймер — обычный
 * setTimeout между запросами; никаких висящих интервалов после завершения.
 */
export async function pollVoiceProfile(id, { until, isCancelled, intervalMs = 3000, timeoutMs = 6 * 60 * 1000 }) {
    const startedAt = Date.now();
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
    // eslint-disable-next-line no-constant-condition
    while (true) {
        if (isCancelled())
            throw new PollCancelledError();
        if (Date.now() - startedAt > timeoutMs)
            throw new PollTimeoutError();
        const profile = await getVoiceProfile(id);
        if (isCancelled())
            throw new PollCancelledError();
        if (until(profile))
            return profile;
        if (isVoiceProfileFailed(profile)) {
            throw new Error("voice profile failed");
        }
        await sleep(intervalMs);
    }
}
